/**
 * 组织管理页面
 * 包含: 组织信息、部门管理、成员管理
 * 
 * 重构后结构:
 * - 业务逻辑: hooks/useOrganizationManagement.ts
 * - Tab组件: components/*Tab.tsx
 * - 弹窗组件: components/*Modal.tsx
 */

import React from 'react';
import { Card, Tabs } from 'antd';
import { TeamOutlined, ApartmentOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useOrganizationManagement } from './hooks';
import { OrganizationInfoTab, DepartmentTab, MemberTab } from './components';
import './OrganizationManagement.css';

const OrganizationManagement: React.FC = () => {
    const navigate = useNavigate();
    const { loading, organization, departments, members, modules, handleDeleteDept } = useOrganizationManagement();

    const tabItems = [
        {
            key: 'info',
            label: (<span><TeamOutlined />组织信息</span>),
            children: <OrganizationInfoTab organization={organization} />,
        },
        {
            key: 'departments',
            label: (<span><ApartmentOutlined />部门管理</span>),
            children: (
                <DepartmentTab
                    departments={departments}
                    modules={modules}
                    onAdd={() => navigate('/organization/departments/new')}
                    onEdit={(dept) => navigate(`/organization/departments/${dept.id}`)}
                    onDelete={handleDeleteDept}
                />
            ),
        },
        {
            key: 'members',
            label: (<span><UserOutlined />成员管理</span>),
            children: <MemberTab members={members} onEdit={(member) => navigate(`/organization/members/${member.id}`)} onAdd={() => navigate('/organization/members/new')} />,
        },
    ];

    return (
        <div className="organization-management">
            <Card title="组织管理" loading={loading}>
                <Tabs defaultActiveKey="info" items={tabItems} />
            </Card>
        </div>
    );
};

export default OrganizationManagement;
